import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { configure } from 'axios-hooks'
import Axios from 'axios'
import { AuthProvider, useIsAuthenticated } from 'react-auth-kit'
import BulkCodes from './BulkCodes';
import Login from './Login';
import LoginBulkCodes from './LoginBulkCodes';
const axios = Axios.create({
  baseURL: process.env.REACT_APP_API_URL
})
configure({ axios, cache: false })
const PrivateRoute = ({ children, loginPath }) => {
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();

  if (isAuthenticated()) {
    return children;
  }

  return <Navigate
    to={loginPath}
    state={{ from: location }}
    replace
  />;
};
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider authType={'localstorage'}
    authName={'_swiftrev_auth'}>
    <BrowserRouter>
      <Routes>
        <Route path={'/bulk-sales'} element={
          <PrivateRoute loginPath={'/login-bulk-sales'}>
            <BulkCodes />
          </PrivateRoute>
        } />
        <Route path='login-bulk-sales' element={<LoginBulkCodes redirectUrl={'/bulk-sales'} />} />
        <Route path="/:accountId/:brandId/*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </AuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
